import Http from '../api/http/';

export default class CustomerResearchTask extends Http {
  constructor() {
    super();
  }

  /**
   * @description 根据客群调研获取品牌列表
   * @param 无
   */
  customerResearchTask_getBrandListByCustomerResearch() {
    return super.post('customerResearchTask/getBrandListByCustomerResearch', ...arguments);
  }

  /**
   * @description 创建客群调研任务
   * @param {Object} taskInfo - 任务基本信息
   * @param {Object} taskReportInfo - 任务报告配置信息
   * @param {Object} taskDateInfo - 任务时间配置信息
   * @param {Object} taskStoreInfo - 任务门店配置信息
   * @param {Object} publishingRule - 发布规则配置
   */
  customerResearchTask_createCustomerResearchTask() {
    return super.post('customerResearchTask/createCustomerResearchTask', ...arguments);
  }

  /**
   * @description 更新客群调研任务
   * @param {Object} taskInfo - 任务基本信息（需包含 taskId）
   * @param {Object} taskReportInfo - 任务报告配置信息
   * @param {Object} taskDateInfo - 任务时间配置信息
   * @param {Object} taskStoreInfo - 任务门店配置信息
   * @param {Object} publishingRule - 发布规则配置
   */
  customerResearchTask_updateCustomerResearchTask() {
    return super.post('customerResearchTask/updateCustomerResearchTask', ...arguments);
  }

  /**
   * @description 发布客群调研任务
   * @param {Number} taskId - 任务 ID
   */
  customerResearchTask_taskPublish() {
    return super.post('customerResearchTask/taskPublish', ...arguments);
  }

  /**
   * @description 结束客群调研任务
   * @param {Number} taskId - 任务 ID
   */
  customerResearchTask_taskOver() {
    return super.post('customerResearchTask/taskOver', ...arguments);
  }

  /**
   * @description 删除客群调研任务
   * @param {Number} taskId - 任务 ID
   */
  customerResearchTask_taskRemove() {
    return super.post('customerResearchTask/taskRemove', ...arguments);
  }

  /**
   * @description 撤回客群调研任务
   * @param {Number} taskId - 任务 ID
   */
  customerResearchTask_taskRecall() {
    return super.post('customerResearchTask/taskRecall', ...arguments);
  }

  /**
   * @description 修改任务门店详情积分报酬
   * @param {Number} taskStoreDetailId - 任务门店详情 ID
   * @param {Number} pointReward - 积分报酬
   */
  customerResearchTask_changeTaskStoreDetailPointRewardForUpdateTask() {
    return super.post('customerResearchTask/changeTaskStoreDetailPointRewardForUpdateTask', ...arguments);
  }

  /**
   * @description 任务门店导入（按城市）
   * @param {Object} params - 导入参数
   */
  customerResearchTask_taskStoreImportForCity() {
    return super.post('customerResearchTask/taskStoreImportForCity', ...arguments);
  }
}
